// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const deads = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_DEAD':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DEAD':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_DEAD':
      return { ...state }
    case 'EDIT_DEAD':
      return { ...state }
    case 'DELETE_DEAD':
      return { ...state }
    default:
      return { ...state }
  }
}
export default deads
